import React, { useState } from "react";

type TSidebarSearchProps = {
	onSearch: (query: string) => void;
};

const SidebarSearch: React.FC<TSidebarSearchProps> = ({
	onSearch,
}) => {
	const [searchQuery, setSearchQuery] = useState("");

	const handleSearchChange = (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		const query = e.target.value;
		setSearchQuery(query);
		onSearch(query);
	};

	return (
		<div className="sidebar-search-container">
			<input
				type="text"
				className="sidebar-search-input"
				placeholder="Search conversations..."
				value={searchQuery}
				onChange={handleSearchChange}
				autoFocus
			/>
		</div>
	);
};

export default SidebarSearch;
